import React from 'react';

export default function WindowButton({ children, type }) {
  function renderIcon(iconType) {
      switch (iconType) {
        case 'close':
          return (<i className = "icofont-plus"> </i>)
        case 'minimize':
          return (<i className = "icofont-minus"> </i>)
        case 'maximize':
          return (<i className="icofont-expand-alt"></i>)
        default:
            return null;
      }
  }
  return (
    <span className="window__button">
      <span className={`window__button--${type}`}>
        { renderIcon(type) }
      </span>
    </span>
  );
}
